var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgApiIconApiStatic = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "192px",
    viewBox: "0 0 240 192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "API_icon_API_static") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "API_icon_API_static",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#FFFFFF",
    x: 5,
    y: 5.5,
    width: 230,
    height: 180
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame_Static",
    fill: "#D9E8F6",
    stroke: "#D9E8F6",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,6 C10.4771525,6 6,10.4771525 6,16 L6,176 C6,181.522847 10.4771525,186 16,186 L224,186 C229.522847,186 234,181.522847 234,176 L234,16 C234,10.4771525 229.522847,6 224,6 L16,6 Z M9,10 L231,10 L231,182 L9,182 L9,10 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hUzEZV",
    transform: "translate(47.499948, 51.999969)",
    fill: "#003A5D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8780682,80.4927411 C13.516839,80.4927411 1.77536714,70.0598067 0.707317584,57.2432121 C-0.445610078,43.9668611 9.25878718,32.7488042 23.3414803,30.8885589 L23.3414803,30.8249003 C25.2653841,24.9541644 27.9178251,18.3902572 35.4861232,14.1463517 C40.1905285,11.5137722 45.4865061,10.1191972 50.8773539,10.0934219 C55.9398996,10.0993218 60.9262245,11.3270981 65.4127302,13.6724489 C72.2595644,5.11390614 81.2707905,0.594146771 91.5834808,0.594146771 C93.4516606,0.597426917 95.3170237,0.739279623 97.1642166,1.01853732 C112.435203,3.30317312 122.02643,11.6283011 124.898139,25.1663597 C125.362634,27.2969646 125.630184,29.4657756 125.697408,31.6453887 C137.389368,35.0405131 144.915227,45.1480814 144.420104,56.8046752 C143.974494,67.414439 135.359366,77.1400558 123.907894,79.9198139 C122.387903,80.2607121 120.83241,80.4174488 119.274964,80.3866435 L118.12911,80.3866435 L117.004475,80.3866435 C109.294713,80.3866435 101.56609,80.3866435 93.8186044,80.3866435 L72.4929792,80.3866435 C68.0793175,80.3866435 63.6656558,80.3701394 59.2519941,80.3371312 L58.7073595,80.3371312 C54.2936978,80.3371312 49.8163775,80.287619 45.3178376,80.287619 C38.3578326,80.287619 32.6709992,80.3442044 27.4156296,80.4715216 L26.8780682,80.4927411 Z M50.9268661,18.2487937 C46.9164726,18.2596563 42.9759747,19.2995776 39.4824676,21.2690398 C34.955635,23.7800172 33.0670971,27.4297759 31.1714859,33.2934387 L31.0795347,33.5975853 C30.6763636,34.8990496 29.6012409,38.3790521 24.9541644,38.8883208 C15.0092791,39.984663 8.08463999,47.5741807 8.83439663,56.5712604 C9.54171421,65.1298032 17.8244031,72.3585889 26.8922146,72.3585889 L27.2953856,72.3585889 C32.6356333,72.2383449 38.3931985,72.1746863 45.4310085,72.1746863 C49.9719873,72.1746863 54.4917467,72.1746863 58.9549207,72.2241985 L59.3580917,72.2241985 C63.7528916,72.2524913 68.1476915,72.2689953 72.5424915,72.2737108 L93.8751898,72.2737108 C101.608529,72.2737108 109.337152,72.2737108 117.06106,72.2737108 L118.28472,72.2737108 L119.317403,72.2737108 C120.226745,72.3009749 121.136111,72.220248 122.02643,72.0332228 C129.997899,70.0951726 135.995952,63.5454118 136.293025,56.4722359 C136.625465,48.6351571 131.454973,41.8024692 123.426918,39.4966139 C119.656916,38.4073448 117.690573,35.9953919 117.584475,32.3173404 C117.546766,30.4732603 117.328818,28.6372866 116.933743,26.8356292 C114.776424,16.7139145 107.915444,10.899764 95.9688499,9.11025049 C94.4891081,8.88762198 92.9949942,8.77414498 91.4986027,8.77073805 C83.5271335,8.77073805 76.7510311,12.307326 71.3612711,19.3805018 C69.8546846,21.3539179 68.0793175,22.3512357 66.0988283,22.3512357 C64.7398899,22.2995786 63.4151488,21.9106638 62.2439474,21.2195275 C58.7647512,19.2927659 54.8544322,18.2780783 50.8773539,18.2700132 L50.9268661,18.2487937 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8780682,77.8898124 C14.9880596,77.8898124 4.24390551,68.4471226 3.28902677,57.0239437 C2.24926992,44.9853984 11.3170814,34.8212447 24.296359,33.3924632 C25.3290427,33.2792923 25.3856281,33.0812434 25.7109942,31.977828 L25.824165,31.6100228 C27.6419712,25.9514822 29.9902656,20.1868439 36.723929,16.4451338 C45.4332067,11.5172048 56.0794171,11.4770102 64.8256566,16.3390362 C66.1059014,17.0463538 66.1341941,16.9968416 66.891024,16.0065969 C74.4522489,6.10415075 84.7720125,1.86024525 96.7186065,3.62146603 C110.822519,5.74341879 119.671062,13.3753755 122.29521,25.7322137 C122.76375,27.8376864 123.024351,29.9840899 123.07326,32.140511 C123.108626,33.2014874 123.285455,33.6824634 124.919359,34.1563662 C135.451317,37.2049049 142.22742,46.2727164 141.788883,56.7127239 C141.385712,66.1978527 133.605219,74.9049322 123.285455,77.4088364 C121.600031,77.7590957 119.876377,77.8898556 118.157402,77.7978611 L117.025694,77.7978611 C105.416255,77.7978611 93.8115312,77.7978611 82.2115228,77.7978611 L72.4929792,77.7978611 C67.980293,77.7978611 63.4628914,77.781357 58.9407743,77.7483489 C48.5927181,77.6988367 37.891003,77.6351781 27.3802637,77.8898124 L26.8780682,77.8898124 Z M50.9268661,15.645865 C46.4660247,15.6558302 42.082349,16.8101981 38.1951496,18.9985503 C32.9185604,21.9268451 30.6975832,26.1707506 28.6463622,32.5366089 L28.5473377,32.8690482 C28.158313,34.1210003 27.5712394,36.0236846 24.6146519,36.3490507 C13.2409852,37.6010028 5.31902824,46.3929604 6.22439474,56.8046752 C7.07317584,66.8980971 16.6997682,75.1949324 27.3378246,74.9685908 C37.9758811,74.7422492 48.6139376,74.777615 58.9832134,74.8342004 C63.4958996,74.8342004 68.0085857,74.8837127 72.5212719,74.8837127 L82.2398155,74.8837127 C93.8398239,74.8837127 105.44219,74.8837127 117.046914,74.8837127 C117.435939,74.8837127 117.832036,74.8837127 118.221061,74.8837127 C119.692191,74.9707453 121.168408,74.8685274 122.613503,74.5795661 C131.688388,72.3798084 138.528149,64.8256566 138.881808,56.6278458 C139.263759,47.5671076 133.336438,39.6522238 124.134236,37.0210024 C121.467649,36.2500262 120.243989,34.7788056 120.166184,32.2678282 C120.12751,30.2781616 119.890566,28.2973072 119.458867,26.3546532 C117.08228,15.1719622 109.301786,8.50195737 96.336655,6.54976083 C85.3520129,4.90878404 76.2559088,8.67171359 69.2746842,17.8102568 C67.3578536,20.3212342 65.5683401,20.0807462 63.47468,18.9419649 C59.6153096,16.8145518 55.2841853,15.6886054 50.8773539,15.6670845 L50.9268661,15.645865 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeLinejoin: "round",
    points: "61.8514214 143.003449 84.6129012 143.003449 84.6129012 106.583667"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeLinejoin: "round",
    points: "174.350283 143.003449 151.588803 143.003449 151.588803 106.583667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.77195,139.099056 L117.77195,106.583667",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeLinejoin: "round",
    points: "74.8589918 47.996551 97.6133985 47.996551 97.6133985 84.4163335"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeLinejoin: "round",
    points: "161.993445 47.996551 139.231965 47.996551 139.231965 84.4163335"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#B4A269",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "61.8514214 143.003449 84.6129012 143.003449 84.6129012 109.618059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8170499,109.780742 C87.8170499,108.018952 86.3888372,106.59074 84.6270476,106.59074 C82.865258,106.59074 81.4370453,108.018952 81.4370453,109.780742 C81.4370453,111.542532 82.865258,112.970744 84.6270476,112.970744 C86.3872235,112.966854 87.81316,111.540918 87.8170499,109.780742 Z",
    id: "Path",
    fill: "#B4A269",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#B4A269",
    strokeWidth: 4,
    strokeLinejoin: "round",
    cx: 56.9426373,
    cy: 143.293449,
    r: 4.19439328
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#B4A269",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "174.350283 143.003449 151.588803 143.003449 151.588803 109.618059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.778806,109.780742 C154.778806,108.490507 154.001587,107.327316 152.809564,106.833564 C151.617542,106.339812 150.245465,106.612736 149.333131,107.52507 C148.420797,108.437404 148.147874,109.809481 148.641625,111.001503 C149.135377,112.193525 150.298568,112.970744 151.588803,112.970744 C153.348979,112.966854 154.774916,111.540918 154.778806,109.780742 Z",
    id: "Path",
    fill: "#B4A269",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#B4A269",
    strokeWidth: 4,
    strokeLinejoin: "round",
    cx: 179.259067,
    cy: 143.293449,
    r: 4.19439328
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.77195,139.099056 L117.77195,112.680744",
    id: "Path",
    stroke: "#B4A269",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B4A269",
    fillRule: "nonzero",
    points: "122.008782 113.91855 117.77195 106.583667 113.54219 113.91855"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#B4A269",
    strokeWidth: 4,
    strokeLinejoin: "round",
    cx: 117.418291,
    cy: 143.293449,
    r: 4.19439328
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#B4A269",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "74.8589918 47.996551 97.6133985 47.996551 97.6133985 81.381941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4233961,81.219258 C94.4205356,82.5136372 95.1984277,83.6820225 96.393733,84.1786822 C97.5890383,84.675342 98.965871,84.4022636 99.8811376,83.4869971 C100.796404,82.5717306 101.069482,81.1948978 100.572823,79.9995925 C100.076163,78.8042872 98.9077776,78.0263951 97.6133985,78.0292557 C95.8532226,78.0331456 94.4272861,79.4590821 94.4233961,81.219258 Z",
    id: "Path",
    fill: "#B4A269",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#B4A269",
    strokeWidth: 4,
    strokeLinejoin: "round",
    cx: 69.9502077,
    cy: 47.7065508,
    r: 4.19439328
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#B4A269",
    strokeWidth: 4,
    strokeLinejoin: "round",
    points: "161.993445 47.996551 139.231965 47.996551 139.231965 81.381941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.041963,81.219258 C136.041963,82.9810476 137.470175,84.4092603 139.231965,84.4092603 C140.993755,84.4092603 142.421967,82.9810476 142.421967,81.219258 C142.421967,79.4574683 140.993755,78.0292557 139.231965,78.0292557 C137.471789,78.0331456 136.045853,79.4590821 136.041963,81.219258 Z",
    id: "Path",
    fill: "#B4A269",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#B4A269",
    strokeWidth: 4,
    strokeLinejoin: "round",
    cx: 166.902229,
    cy: 47.7065508,
    r: 4.19439328
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgApiIconApiStatic);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/API_icon_API_static.766263479d698262f17bdb8660b62b8d.svg";